import { useState, useEffect } from "react";
import StandardSubSettings from "./SettingsComponents/StandardSubSettings";
import VMAInfo from "./VMAInfo";
import { Typography } from "antd";

const VMA = ({ setHaveNewData, settings, isMobile, apiAdd }) => {
  const [vmaAlerts, setVmaAlerts] = useState([]);

  const [finalData, setFinalData] = useState([]);
  const [initial, setInitial] = useState(true);

  var settingsData = StandardSubSettings(settings, "VMA");

  function APIcall() {
    const fetch = require("node-fetch");
    async function fetchData() {
      let response = await fetch("http://api.sr.se/api/v2/vma?format=json");
      const responseJson = await response.json();
      const exresp = {
        copyright: "Copyright Sveriges Radio 2021. All rights reserved.",
        messages: [
          {
            id: 7721758,
            title: "VMA i Norrköping, Östergötland •",
            description:
              "Viktigt meddelande till allmänheten i Sörby/Bråvalla. Det brinner i en bilverkstad i Sörby. Räddningsledaren uppmanar alla i området att gå inomhus och stänga dörrar, fönster och ventilation. För mer information lyssna på Sveriges Radio P4 Östergötland.",
            date: "/Date(1618917900000+0200)/",
            url: "https://sverigesradio.se/artikel/7721753",
          },
          {
            id: 7721759,
            title: "VMA i Mariestad, Västergötland •",
            description:
              "Viktigt meddelande till allmänheten. Det brinner på stadshotellet. Räddningsledaren uppmanar alla i området att gå inomhus och stänga dörrar, fönster och ventilation. För mer information lyssna på Sveriges Radio P4 Östergötland.",
            date: "/Date(1618917900000+0200)/",
            url: "https://sverigesradio.se/artikel/7721753",
          },
        ],
      };

      //return exresp if example data is needed
      return responseJson;
    }

    fetchData().then((r) => {
      setVmaAlerts(r.messages);
    });
  }

  useEffect(() => {
    APIcall();
    const interval = setInterval(APIcall, 65000);
    return () => clearInterval(interval);
  }, []);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const sendInfo = () => {
    if (vmaAlerts[0] != null) setInitial(false);

    //console.log("This is alert data: " + JSON.stringify(alertData))
    if (vmaAlerts[0] != null) {
      vmaAlerts.forEach((value, index) => {
        if (vmaAlerts.length === 0) {
          setHaveNewData && setHaveNewData(false);
        } else {
          setHaveNewData && setHaveNewData(true);

          const dateFormated = 999999999999999999;
          console.log("Formated date: " + dateFormated);
          setFinalData((finalData) => [
            ...finalData,
            {
              idArray: 2,
              key: value.id,
              desc: value.description,
              title: value.title,
              url: value.url,
              id: value.id,
              date: value.date,
              notification: settingsData.notification,
            },
          ]);
        }
      });
    }
  };

  useEffect(() => {
    if (isMobile === "true") apiAdd(finalData);
  }, [finalData]);

  useEffect(() => {
    console.log(vmaAlerts);
    if (initial && isMobile === "true") {
      console.log("attempt");
      sendInfo();
    }
  }, [vmaAlerts]);

  var apiData =
    vmaAlerts.length === 0
      ? setHaveNewData && setHaveNewData(false)
      : vmaAlerts.map((value, index) => {
          setHaveNewData && setHaveNewData(true);
          return (
            <>
              {isMobile === "true" ? (
                <></>
              ) : (
                <VMAInfo
                  key={value.id}
                  desc={value.description}
                  title={value.title}
                  url={value.url}
                  id={value.id}
                  date={value.date}
                  notification={settingsData.notification}
                />
              )}
            </>
          );
        });

  var empty = vmaAlerts.length === 0;

  return (
    <>
      {empty ? (
        <>
          {isMobile === "true" ? (
            <></>
          ) : (
            <>
              <Typography.Title level={5} className="tileHeader">
                Inget VMA utfärdat
              </Typography.Title>
            </>
          )}
        </>
      ) : (
        <>{apiData}</>
      )}
    </>
  );
};

export default VMA;
